import React from 'react'
import './project.css'
import Lottie from "lottie-react";

import TextBlock from './textBlock'
import { Parallax, ParallaxLayer } from '@react-spring/parallax'
import scroll from "./../lottie/scroll.json";
const Project = () => {

  return (
    <div className="App">
      <Parallax pages={2} style={{ top: '0', left: '0' }} class="animation">
        <ParallaxLayer offset={0} speed={0.25}>
          <div class="animation_layer parallax" id="artback">

            </div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.3}>
          <div class="animation_layer parallax" id="mountain">
          </div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={-0.1}>
          <div class="animation_layer parallax" id="logoland"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.3}>
          <div class="animation_layer parallax flex mt-32 justify-center" id="jungle1">

            <div className='h-72 bg-[#3A3A3A] bg-opacity-75 rounded-lg w-full  md:w-2/5 lg:w-[700px] p-6'><h1 className='text-center text-lg text-yellow-600 font-bold tracking-widest'>PROJECTS</h1>
            <div className='row h-full flex flex-col md:flex-row lg:flex-row '>
            <div className="w-full sm:w-4/5 md:w-4/5 lg:w-4/5 xl:w-3/5 inline-block"><p className='text-md font-semibold text-justify'>Explore my Awesome projects to witness my expertise. In web development, I create responsive, visually appealing websites with seamless UI and interactive elements. For the Android, I craft feature-rich apps with intuitive interfaces and smooth performance. Check out my work to see how I can bring value to your team............................ Let's connect and discuss potential collaborations.</p></div>
      <div className="w-full sm:w-1/5 md:w-1/5 lg:w-1/5 xl:w-2/5 inline-block justify-end flex"><Lottie  animationData={scroll}/></div>

            </div>
            </div>
          </div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.35}>
          <div class="animation_layer parallax" id="jungle2"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.5}>
          <div class="animation_layer parallax" id="jungle3"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.45}>
          <div class="animation_layer parallax" id="jungle4"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.40}>
          <div class="animation_layer parallax" id="manonmountain">

          </div>
        </ParallaxLayer>
        <ParallaxLayer offset={0} speed={0.35}>
          <div class="animation_layer parallax" id="jungle5"></div>
        </ParallaxLayer>
        <ParallaxLayer offset={1} speed={0.25}>
          <TextBlock />
        </ParallaxLayer>
      </Parallax>
    </div>
  )
}

export default Project
